import { h } from 'preact'
import ButtonControlSelector from '../button-control-selector'

interface Props {
  showEvent: boolean,
  inGroup?: number
}

const TopicSelector = ({showEvent, inGroup}: Props) => {
  const urlSuffix = inGroup ? 'group=' + inGroup : ''
  const getSelectorItems = () => {
    const contentTypes = [
      {
        isPrincipal: true,
        title: 'New article',
        href: `/content/new/article?${urlSuffix}`
      },
      {
        title: 'New conversation',
        href: `/topic/new?content_type=discussion&${urlSuffix}`
      },
      {
        title: 'New question',
        href: `/topic/new?content_type=question&${urlSuffix}`
      }
    ]

    if (showEvent) {
      contentTypes.push({
        title: 'New event',
        href: '/content/new/event'
      })
    }

    return contentTypes
  }

  return <div>
    <ButtonControlSelector items={getSelectorItems()} />
  </div>
}

export default TopicSelector
